import { BaseTextFieldProps, Grid, MenuItem, TextField } from '@mui/material'
import React from 'react'
import { RegisterOptions, UseFormRegister } from 'react-hook-form'

interface Sizing {
  xs: number
  sm: number
  md: number
  lg: number
  xl: number
}

interface IFormSelect extends BaseTextFieldProps {
  disabled: boolean
  error: boolean
  errorMessage: string | undefined
  label: string
  sizing: Sizing
  register?: UseFormRegister<any>
  rules?: RegisterOptions
  name: string
  options: any[]
  value: string
}

const FormSelect: React.FC<IFormSelect> = ({
  disabled,
  error,
  errorMessage,
  label,
  sizing,
  register,
  name,
  options,
  rules = {},
  ...FormInputProps
}) => {
  return (
    <Grid
      item
      xs={sizing.xs}
      sm={sizing.sm}
      md={sizing.md}
      lg={sizing.lg}
      xl={sizing.xl}
    >
      <TextField
        id={name}
        select
        error={error}
        helperText={errorMessage}
        label={label}
        variant='outlined'
        margin='dense'
        size='small'
        fullWidth={true}
        InputLabelProps={{ shrink: true }}
        disabled={disabled}
        {...register!(name, rules)}
        {...FormInputProps}
      >
        {options.map((item) => (
          <MenuItem
            key={item.id}
            value={item.id}
          >
            {item.name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  )
}

export default FormSelect

/*
Exemplo de uso:

  <Form.Select
    label='Nome Fantasia'
    error={!!errors.tradingName}
    errorMessage={errors?.tradingName?.message}
    disabled={isLoading || readonly}
    sizing={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
    name="tradingName"
    rules={{ onChange: (e) => {
      setValue("tradingName", e.target.value)
      handleChange(e)
    }}}
    register={register}
    value={`${watch().tradingName}`}
    options={tradingNameOptions}
  />
*/
